var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-canvas"},[_c('img',{attrs:{"src":_vm.url},on:{"click":_vm.getCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }